import React, { useEffect, useRef, useState } from 'react';
import { getBookingById } from '../reducers/BookingSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import CircularProgress from '@mui/material/CircularProgress';
import { fetchStudentById } from '../reducers/StudentSlice';
import { fetchRoomById } from '../reducers/RoomSlice';
import { useReactToPrint } from 'react-to-print';
import moment from 'moment/moment';

const ViewBookings = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const { booking, status, error } = useSelector(state => state.bookings);
    const { student, studentStatus, studentError } = useSelector(state => state.students);
    const { room, roomStatus, roomError } = useSelector(state => state.rooms);
    const [currentDateTime, setCurrentDateTime] = useState('');

    const printRef = useRef();

    const handlePrint = useReactToPrint({
        contentRef: printRef,            // <-- v3: use this
        documentTitle: "Student Report",
        onAfterPrint: () => console.log("Printed!"),
    });

    useEffect(() => {
        if (id) {
            dispatch(getBookingById(id));
        }
    }, [id, dispatch]);

    useEffect(() => {
        if (booking?.data?.studentId) {
            dispatch(fetchStudentById(booking.data.studentId));
        }
    }, [booking, dispatch]);

    useEffect(() => {
        if (booking?.data?.selectedRoom) {
            dispatch(fetchRoomById(booking.data.selectedRoom));
        }
    }, [booking, dispatch]);

    useEffect(() => {
        const date = new Date();
        setCurrentDateTime(date.toLocaleString());
    }, []);

    if (status === 'loading' || studentStatus === 'loading' || roomStatus === 'loading') {
        return <div className="d-flex justify-content-center align-items-center h-100"><CircularProgress /></div>;
    }

    if (status === 'failed' || studentStatus === 'failed' || roomStatus === 'failed') {
        return <div>Failed to load data: {error || studentError || roomError}</div>;
    }

    if (!booking) {
        return <div>No booking data available.</div>;
    }

    const getMonthName = (monthNumber) => {
        const monthNames = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ];
        // Ensure the monthNumber is valid
        return monthNumber >= 1 && monthNumber <= 12 ? monthNames[monthNumber - 1] : null;
    };

    const totalPaidAmount = booking?.data?.paymentHistory?.reduce(
        (sum, payment) => sum + (payment.amount || 0),
        0
    ) || 0;

    const remainingAmount = (booking?.data?.totalPayment || 0) - totalPaidAmount;


    // const handlePrint = () => {
    //     const printWindow = window.open('', '_blank', 'width=800,height=600');
    //     const totalPaidAmount = booking?.data?.paymentHistory?.reduce(
    //         (sum, payment) => sum + (payment.amount || 0),
    //         0
    //     ) || 0;

    //     const paymentHistoryRows = booking?.data?.paymentHistory?.length
    //         ? `
    //     <tr>
    //         <td>1</td>
    //         <td>${booking?.data?.paymentHistory.at(-1).amount.toLocaleString() || 'N/A'}</td>
    //         <td>${booking?.data?.paymentHistory.at(-1).date ? new Date(booking?.data?.paymentHistory.at(-1).date).toLocaleDateString() : 'N/A'}</td>
    //         <td>${booking?.data?.paymentHistory.at(-1).time || 'N/A'}</td>
    //         <td>${getMonthName(booking?.data?.paymentHistory.at(-1).month) || 'N/A'}</td>
    //     </tr>
    //   `
    //         : '<tr><td colspan="5">No Payment History Available</td></tr>';

    //     printWindow.document.write(`
    //         <html>
    //             <head>
    //                 <title>Booking Details</title>
    //                 <!-- Preconnect to Google Fonts -->
    //                 <link rel="preconnect" href="https://fonts.googleapis.com">
    //                 <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    //                 <link href="https://fonts.googleapis.com/css2?family=Noto+Nastaliq+Urdu:wght@400..700&display=swap" rel="stylesheet">
    //                 <style>
    //                     body { font-family: "Poppins", serif; margin: 20px; color: #333; }
    //                     .container { max-width: 800px; margin: 0 auto; }
    //                     .same-divs { margin-bottom: 10px; }
    //                     .text-center { text-align: center; }
    //                     h3 { color: #333; margin-top: 20px; }
    //                     .table {
    //                         width: 100%;
    //                         border-collapse: collapse;
    //                         margin-top: 20px;
    //                     }
    //                     .table th, .table td {
    //                         border: 1px solid #ddd;
    //                         padding: 6px;
    //                         text-align: left;
    //                     }
    //                     .table th {
    //                         background-color: #f4f4f4;
    //                         font-weight: bold;
    //                     }
    //                     .table-striped tr:nth-child(even) {
    //                         background-color: #f9f9f9;
    //                     }
    //                     .date-time {
    //                         position: absolute; 
    //                         bottom: 10px; 
    //                         right: 20px; 
    //                         font-size: 14px; 
    //                         color: #333; 
    //                     }
    //                     .student-signature {
    //                         position: absolute; 
    //                         bottom: 50px; 
    //                         left: 20px; 
    //                         font-size: 14px; 
    //                         color: #333; 
    //                     }
    //                     .manager-signature {
    //                         position: absolute; 
    //                         bottom: 50px; 
    //                         right: 20px; 
    //                         font-size: 14px; 
    //                         color: #333; 
    //                     }
    //                     /* Applying Noto Nastaliq Urdu font to Urdu text */
    //                     .noto-nastaliq-urdu-urdu-text {
    //                         font-family: "Noto Nastaliq Urdu", serif;
    //                         font-weight: 400;
    //                         font-style: normal;
    //                         direction: rtl; /* Ensures correct text direction for Urdu */
    //                         text-align: right;
    //                         font-display: swap; /* Ensures text is visible while loading */
    //                     }
    //                     /* Ensure proper font on print */
    //                     @media print {
    //                         body {
    //                         font-family: "Poppins", serif;
    //                         }
    //                         .noto-nastaliq-urdu-urdu-text {
    //                             font-family: "Noto Nastaliq Urdu", serif !important;
    //                             font-weight: 400;
    //                             font-style: normal;
    //                             direction: rtl;
    //                             font-optical-sizing: auto;
    //                         }
    //                     }
    //                 </style>
    //             </head>
    //             <body>
    //                 <div class="container">
    //                     <h2 class="text-center">AK Boys Hostel</h2>
    //                     <h3 class="text-center">Booking Details</h3>
    //                     <table class="table">
    //                         <tr>
    //                             <th>Customer ID</th>
    //                             <td>${student?._id || ''}</td>
    //                             <th>Customer Name</th>
    //                             <td>${booking?.data?.studentName || ''}</td>
    //                         </tr>
    //                         <tr>
    //                             <th>Father Name</th>
    //                             <td>${student?.fatherName || ''}</td>
    //                             <th>Customer Phone</th>
    //                             <td>${student?.contactNumber || ''}</td>
    //                         </tr>
    //                         <tr>
    //                             <th>Customer Address</th>
    //                             <td>${student?.currentAddress || ''}</td>
    //                             <th>Room No</th>
    //                             <td>${room?.roomNumber || ''} 
    //                                 ${(room?.roomNumber && /Room (1|13|14|26|27)/.test(room?.roomNumber)) ? '(VIP)' : ''}
    //                             </td>
    //                         </tr>
    //                         <tr>
    //                             <th>Room Type</th>
    //                             <td>${room?.roomType || ''}</td>
    //                             <th>Room Capacity</th>
    //                             <td>${room?.capacity || ''}</td>
    //                         </tr>
    //                         <tr>
    //                             <th>Room Price</th>
    //                             <td>${room?.monthlyRent || ''}</td>
    //                             <th>Room Status</th>
    //                             <td>${room?.roomStatus || ''}</td>
    //                         </tr>
    //                         <tr>
    //                             <th>Booking ID</th>
    //                             <td>${booking?.data?._id || ''}</td>
    //                             <th>Booking Date</th>
    //                             <td>${booking?.data?.bookingDate ? new Date(booking?.data?.bookingDate).toLocaleDateString() : ''}</td>
    //                         </tr>
    //                         <tr>
    //                             <th>Time Periods</th>
    //                             <td>${(booking?.data?.durationValue && booking?.data?.durationType) ? `${booking?.data?.durationValue} ${booking?.data?.durationType}` : ''}</td>
    //                             <th>Advanced Payment</th>
    //                             <td>${booking?.data?.advancedPayment?.toLocaleString() || ''}</td>
    //                         </tr>
    //                         <tr>
    //                             <th>Total Paid Amount</th>
    //                             <td>${totalPaidAmount.toLocaleString()}</td>
    //                             <th>Total Payment</th>
    //                             <td>${booking?.data?.totalPayment?.toLocaleString() || ''}</td>
    //                         </tr>
    //                         <tr>
    //                             <th>Security Charges</th>
    //                             <td>${booking?.data?.securityCharges?.toLocaleString() || ''}</td>
    //                             <th>Remaining Amount</th>
    //                             <td>${remainingAmount >= 0 ? remainingAmount?.toLocaleString() : 'Error in Calculation'}</td>
    //                         </tr>
    //                         <tr>
    //                             <th>Payment Mode</th>
    //                             <td>${booking?.data?.paymentMode || ''}</td>
    //                             <th>Payment Status</th>
    //                             <td>${booking?.data?.paymentStatus || ''}</td>
    //                         </tr>
    //                         <tr>
    //                             <th>Security Payment Mode</th>
    //                             <td>${booking?.data?.securityPaymentMode || ''}</td>
    //                             <th>Paid Months</th>
    //                             <td>${booking?.data?.paidMonths || ''}</td>
    //                         </tr>
    //                     </table>
    //                     <h3>Payment History</h3>
    //                     <table class="table table-striped">
    //                         <thead>
    //                             <tr>
    //                                 <th>#</th>
    //                                 <th>Amount</th>
    //                                 <th>Date</th>
    //                                 <th>Time</th>
    //                                 <th>Month</th>
    //                             </tr>
    //                         </thead>
    //                         <tbody>
    //                             ${paymentHistoryRows}
    //                         </tbody>
    //                     </table>
    //                     <div class="date-time"><strong>Printed on:</strong> ${new Date().toLocaleString()}</div>
    //                     <div class="student-signature"><strong>Customer Signature:</strong>_________________</div>
    //                     <div class="manager-signature"><strong>Manager Signature:</strong>_____________________________</div>
    //                     <div class="static-notes mt-4 p-3 border rounded noto-nastaliq-urdu-urdu-text">
    //                         <h3 class="text-primary noto-nastaliq-urdu-urdu-text">اہم ہدایات</h3>
    //                         <ul class="list-unstyled text-white">
    //                             <li class='noto-nastaliq-urdu-urdu-text'>ہاسٹل چھوڑنے سے دس دن قبل تحریری طور پر مطلع کرنا ہوگا۔</li>
    //                             <li class='noto-nastaliq-urdu-urdu-text'>ہاسٹل واجبات ہر ماہ کی 5 تاریخ تک جمع کروانے ہوں گے۔</li>
    //                             <li class='noto-nastaliq-urdu-urdu-text'>اچانک جانے والے طالب علم سے ایک ماہ کی فیس وصول کی جائے گی۔</li>
    //                             <li class='noto-nastaliq-urdu-urdu-text'>ہاسٹل کی کسی چیز کے نقصان کرنے پر اس چیز کی قیمت ادا کرنی ہوگی۔</li>
    //                             <li class='noto-nastaliq-urdu-urdu-text'>روم کی چابی گم ہونے کی صورت میں 500 روپے جرمانہ ادا کرنا ہوگا</li>
    //                         </ul>
    //                     </div>
    //                 </div>
    //             </body>
    //         </html>
    //     `);
    //     printWindow.document.close();
    //     printWindow.print();
    // };


    return (
        <div className="container my-4 text-white card-height">
            <div className="row" id="roomContainer">
                <div className="col">
                    <div className="card-body">
                        <div className="card room-card p-4 bg-white text-dark" ref={printRef}>
                            <h2 className="text-center text-dark mb-2">AK Boys Hostel</h2>
                            <div className="table-responsive bg-white">
                                <table className="table table-bordered table-striped text-center bg-white">
                                    <thead className='bg-white'>
                                        <tr>
                                            <th className='bg-white'>Label 1</th>
                                            <th>Data 1</th>
                                            <th>Label 2</th>
                                            <th>Data 2</th>
                                        </tr>
                                    </thead>
                                    <tbody className='bg-white'>
                                        <tr>
                                            <td>Customer Name</td>
                                            <td>{booking?.data?.studentName || ''}</td>
                                            <td>Customer Email</td>
                                            <td>{student?.email || ''}</td>
                                        </tr>
                                        <tr>
                                            <td>Father Name</td>
                                            <td>{student?.fatherName || ''}</td>
                                            <td>Paid Months</td>
                                            <td>{booking?.data?.paidMonths || ''}</td>
                                        </tr>
                                        <tr>
                                            <td>Customer Phone</td>
                                            <td>{student?.contactNumber || ''}</td>
                                            <td>Customer Address</td>
                                            <td>{student?.currentAddress || ''}</td>
                                        </tr>
                                        <tr>
                                            <td>Room No</td>
                                            <td>
                                                {room?.roomNumber || ''}
                                                {room?.roomNumber && /Room (1|13|14|26|27)/.test(room?.roomNumber) && <span>(VIP)</span>}
                                            </td>
                                            <td>Room Type</td>
                                            <td>{room?.roomType || ''}</td>
                                        </tr>
                                        <tr>
                                            <td>Room Capacity</td>
                                            <td>{room?.capacity || ''}</td>
                                            <td>Room Price</td>
                                            <td>{room?.monthlyRent || ''}</td>
                                        </tr>
                                        <tr>
                                            <td>Booking Id</td>
                                            <td>{booking?.data?._id || ''}</td>
                                            <td>Booking Date</td>
                                            <td>{booking?.data?.bookingDate ? moment(booking.data.bookingDate).format('MMMM Do YYYY') : ''}</td>
                                        </tr>
                                        <tr>
                                            <td>Time Period</td>
                                            <td>{booking?.data?.durationValue?.toLocaleString() + ' ' + booking?.data?.durationType || ''}</td>
                                            <td>Advanced Payment</td>
                                            <td>{booking?.data?.advancedPayment?.toLocaleString() || ''}</td>
                                        </tr>
                                        <tr>
                                            <td>Total Payment</td>
                                            <td>{booking?.data?.totalPayment?.toLocaleString() || ''}</td>
                                            <td>Remaining Amount</td>
                                            <td>{remainingAmount.toLocaleString() || ''}</td>
                                        </tr>
                                        <tr>
                                            <td>Security Charges</td>
                                            <td>{booking?.data?.securityCharges?.toLocaleString() || ''}</td>
                                            <td>Total Paid Amount</td>
                                            <td>{totalPaidAmount.toLocaleString() || ''}</td>
                                        </tr>
                                        <tr>
                                            <td>Payment Mode</td>
                                            <td>{booking?.data?.paymentMode || ''}</td>
                                            <td>Payment Status</td>
                                            <td>{booking?.data?.paymentStatus || ''}</td>
                                        </tr>
                                        <tr>
                                            <td>Security Payment Mode</td>
                                            <td>{booking?.data?.securityPaymentMode || ''}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div className="payment-history-section">
                                <h3 className="text-center text-dark mb-2">Payment History</h3>
                                <div className="table-responsive">
                                    {booking?.data?.paymentHistory && booking.data.paymentHistory.length > 0 ? (
                                        <table className="table table-bordered table-striped text-white">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Amount</th>
                                                    <th>Date</th>
                                                    <th>Time</th>
                                                    <th>Month</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {/* Get the latest payment */}
                                                {(() => {
                                                    const latestPayment = booking.data.paymentHistory[booking.data.paymentHistory.length - 1];
                                                    return (
                                                        <tr key={latestPayment._id}>
                                                            <td>1</td>
                                                            <td>{latestPayment.amount.toLocaleString() || ''}</td>
                                                            <td>
                                                                {latestPayment.date
                                                                    ? new Date(latestPayment.date).toLocaleDateString('en-US', {
                                                                        weekday: 'short', // 'Mon', 'Tue', etc.
                                                                        year: 'numeric',
                                                                        month: 'short', // 'Jan', 'Feb', etc.
                                                                        day: 'numeric'
                                                                    })
                                                                    : ''}
                                                            </td>
                                                            <td>{new Date(latestPayment.time).toLocaleTimeString('en-US', {
                                                                hour: 'numeric',
                                                                minute: 'numeric',
                                                                second: 'numeric',
                                                                hour12: true
                                                            }) || ''}</td>
                                                            <td>{getMonthName(latestPayment.month) || ''}</td>
                                                        </tr>
                                                    );
                                                })()}
                                            </tbody>
                                        </table>
                                    ) : (
                                        <div>No Payment History Available</div>
                                    )}
                                </div>
                            </div>
                            <div className="static-notes mt-4 p-3 border rounded noto-nastaliq-urdu-urdu-text text-dark">
                                <h3 className="text-primary noto-nastaliq-urdu-urdu-text">اہم ہدایات</h3>
                                <ul className="list-unstyled text-white">
                                    <li className='noto-nastaliq-urdu-urdu-text'>ہاسٹل چھوڑنے سے دس دن قبل تحریری طور پر مطلع کرنا ہوگا۔</li>
                                    <li className='noto-nastaliq-urdu-urdu-text'>ہاسٹل واجبات ہر ماہ کی 5 تاریخ تک جمع کروانے ہوں گے۔</li>
                                    <li className='noto-nastaliq-urdu-urdu-text'>اچانک جانے والے طالب علم سے ایک ماہ کی فیس وصول کی جائے گی۔</li>
                                    <li className='noto-nastaliq-urdu-urdu-text'>ہاسٹل کی کسی چیز کے نقصان کرنے پر اس چیز کی قیمت ادا کرنی ہوگی۔</li>
                                    <li class='noto-nastaliq-urdu-urdu-text'>روم کی چابی گم ہونے کی صورت میں 500 روپے جرمانہ ادا کرنا ہوگا</li>
                                </ul>
                            </div>
                            <div >
                                <div class="date-time"><strong>Printed on:</strong> {new Date().toLocaleString()}</div>
                                <div className='d-flex justify-content-between align-items-center mt-5'>
                                    <div class="student-signature"><strong>Customer Signature:</strong>___________</div>
                                    <div class="manager-signature"><strong>Manager Signature:</strong>________________</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="print-btn text-center">
                <button onClick={handlePrint} className="btn btn-primary mt-4" style={{ width: '160px' }}>Print Booking</button>
            </div>
        </div>
    );
};

export default ViewBookings;
